// extracted by mini-css-extract-plugin
export default {"container":"language_container__gIB9E","overlay":"language_overlay__0rj3H","active":"language_active__yQ1fZ","list":"language_list__ciU6-"};